/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit } from '@angular/core';
import { IonRouterOutlet, ModalController, NavParams, Platform } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { PurchaseService } from 'src/app/services/purchase.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-avocado-promotion',
  templateUrl: './avocado-promotion.page.html',
  styleUrls: ['./avocado-promotion.page.scss'],
  providers:[IonRouterOutlet]
  })
export class AvocadoPromotionPage implements OnInit {

  public discountPercentage: number = 30;
  public originalPrice: string = '$12.00';
  public discountedPrice: string = '$8.40';
  public timeLeft: string = '00:00:00';
  public promoClientEndsCalculated : number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public promotion: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public userData : any;
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public backButton: Subscription|any;

  constructor(public modalCtrl: ModalController, 
              private platform: Platform,
              public navParams: NavParams,
              public purchaseServiceProvider: PurchaseService,) {



    const now = new Date();
    this.promoClientEndsCalculated = now.getTime()+ 1000*60*60*24;
    platform.ready().then(() => {


      Preferences.get({key:'USER_DATA'}).then((valUserData) => {
        valUserData = valUserData.value ? JSON.parse(valUserData.value) : null;
        this.userData = valUserData;
        Preferences.get({key:'LOCAL_PROMOTION'}).then((val) => {
          val = val.value ? JSON.parse(val.value) : null;
          if(val != null){
            this.promotion = val;
            if(this.promotion.promoClientEndsCalculated != null){
              this.promoClientEndsCalculated = this.promotion.promoClientEndsCalculated;
            } else{
              const clientDurationHours = Number(this.promotion.clientDuration);
              if (!Number.isNaN(clientDurationHours) && clientDurationHours > 0) {
                this.promoClientEndsCalculated = now.getTime() + clientDurationHours * 1000 * 60 * 60;
              }

              this.promotion.promoClientEndsCalculated = this.promoClientEndsCalculated;
              Preferences.set({key:'LOCAL_PROMOTION', value: JSON.stringify(this.promotion)}).then((_val) => {
                console.log('LOCAL_PROMOTION saved to DB');
              });
            }
                        this.setupTimer(this.promoClientEndsCalculated);
          }

        });
      });
      //this.userData = navParams.get("me");



    });
  }

  ngOnInit() {
  }

  ionViewWillLeave(){
    if(this.platform.is('android')) {
      if(this.backButton){
        this.backButton.unsubscribe();
      }
    }
  }

  ionViewWillEnter(){
    if(this.platform.is('android')) {
      this.backButton = this.platform.backButton.subscribe(() => {
        this.closePromo()
      });
    }
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AvocadoPromotionPage');
  }

  closePromo(){
    if(this.theTimer != null){
      try {
        clearInterval(this.theTimer);
      } catch (error) {
        // ignore
      }
    }

    
    this.modalCtrl.dismiss();
  }


  join(){
    this.purchaseServiceProvider.purchase(this.userData, this.purchaseServiceProvider.club_30percent_off_Id, { digits: 0 });
  }

  formatNoDecimal(num: number) {
    return (Math.round(num * 100) / 100).toFixed(0);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private theTimer:any = null;

  setupTimer(promoClientEndsCalculated : number){

    this.theTimer = setInterval(() => {
      const nowNumber: number = (new Date()).getTime();
      const distance: number = promoClientEndsCalculated - nowNumber;
      
      if(distance<1){
        Preferences.remove({key:'LOCAL_PROMOTION'}).then((_val) => {
          console.log('LOCAL_PROMOTION removed from DB');
        });
        this.closePromo();
        return;
      }
      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      //console.log(this.timeLeft);


      this.timeLeft = hours + ':' + minutes + ':' + seconds;
      document.getElementById("timeLeftSpan")!.innerHTML = this.timeLeft;

    },1000);

  }

}
